/**
 * The header's "Show sources" toggle: display only, nothing is sent to MAIA.
 * One value for the whole page (every patient, the tile and its expanded copy),
 * remembered in this browser so the user's choice survives a reload.
 */
import create from 'zustand';

const STORAGE_KEY = 'maia-show-sources';

const read = (): boolean => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'true';
  } catch (error) {
    return false;
  }
};

const write = (value: boolean) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, String(value));
  } catch (error) {
    // private window or blocked storage: the choice lasts until reload
  }
};

type ShowSourcesState = {
  showSources: boolean;
  setShowSources: (value: boolean) => void;
};

const useShowSourcesStore = create<ShowSourcesState>((set) => ({
  showSources: read(),
  setShowSources: (value) => {
    write(value);
    set({ showSources: value });
  },
}));

export const setShowSources = (value: boolean) =>
  useShowSourcesStore.getState().setShowSources(value);

/** Tests only: read the value from storage again. */
export const resetShowSources = () =>
  useShowSourcesStore.setState({ showSources: read() });

export const useShowSources = (): [boolean, (value: boolean) => void] => [
  useShowSourcesStore((s) => s.showSources),
  setShowSources,
];
